import React from "react";
import { useState, useEffect } from "react";
import {
  Flex,
  Group,
  Box,
  Button,
  Title,
  Textarea,
  Tooltip,
} from "@mantine/core";
import { CustomAiRobot, CustomDrawer } from "@components/custom";

import "@scss/globals.scss";
import styles from "@scss/drawers/ai-drawer.module.scss";

// Global function to open AI drawer from anywhere
let globalOpenAiDrawer: (() => void) | null = null;

export const openAiDrawerGlobally = () => {
  if (globalOpenAiDrawer) {
    globalOpenAiDrawer();
  }
};

export const AiDrawer = () => {
  const [opened, setOpened] = useState(false);

  // Register global function
  useEffect(() => {
    globalOpenAiDrawer = () => setOpened(true);

    // Cleanup on unmount
    return () => {
      globalOpenAiDrawer = null;
    };
  }, []);
  return (
    <>
      <Group mt="xl" mb="xl" className={styles.floatingAiButtonGroup}>
        <Button
          variant="ghost"
          onClick={() => setOpened(true)}
          className={styles.floatingAiButton}
        >
          <CustomAiRobot hover />
        </Button>
      </Group>
      <CustomDrawer
        opened={opened}
        onClose={() => setOpened(false)}
        size="xl"
        position="right"
        variant="ai"
        footer={false}
        className={styles.drawerContainer}
      >
        <CustomDrawer.Header
          topAction="close"
          backUrl=""
          onClose={() => setOpened(false)}
        >
          <Flex gap="md" justify="left" align="center">
            <CustomAiRobot scale={0.7} />
            <Title variant="sky" order={2}>
              Ai Assistant
            </Title>
          </Flex>
        </CustomDrawer.Header>
        <CustomDrawer.Body className={styles.drawerBody}>
          <Box
            className={`${styles.chatContainer} bg--grey900 border--sky br--lg`}
          ></Box>
          <Flex
            my={"lg"}
            gap="md"
            align="center"
            className={styles.inputContainer}
          >
            <Textarea
              placeholder="Ask anything..."
              className={styles.textareaWrapper}
              autosize
              minRows={2}
              maxRows={3}
            ></Textarea>
            <Tooltip label="Send">
              <Button variant="primary-icon" size="sm">
                <></>
              </Button>
            </Tooltip>
          </Flex>
        </CustomDrawer.Body>
      </CustomDrawer>
    </>
  );
};
